import React from 'react';
import { useNavigate } from 'react-router-dom';

import { LoginState } from '@common/react/store/Login';

import { AppRoute, PetProfileTab } from '@app/components/LocalCommon/const';
import CustomModal from '@app/components/UI/Modal/CustomModal';
import { User } from '@app/objects/User';

interface LoginModalProps {
	modalVisible: boolean;
	setModalVisible: (e: boolean) => void;
	login: LoginState<User>;
}

const LoginModal: React.FC<LoginModalProps> = ({
	modalVisible,
	setModalVisible,
	children,
	login,
}) => {
	const navigate = useNavigate();

	React.useEffect(() => {
		if (login.user) {
			if (login.user.defaultPetId && login.user.defaultPetId > 0) {
				return navigate(`${AppRoute.PET_PROFILE}/${login.user.defaultPetId}/${PetProfileTab.DASHBOARD}`);
			} else {
				return navigate(AppRoute.PETS);
			}
		}
	}, [login.user]);

	return (
		<CustomModal modalVisible={modalVisible} setModalVisible={setModalVisible}>
			{children}
		</CustomModal>
	);
};

export default LoginModal;
